import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconPlusSmall({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M6 4V.496A.504.504 0 0 0 5.495 0h-.99A.498.498 0 0 0 4 .496V4H.496A.504.504 0 0 0 0 4.505v.99C0 5.778.222 6 .496 6H4v3.504c0 .268.226.496.505.496h.99A.498.498 0 0 0 6 9.504V6h3.504A.504.504 0 0 0 10 5.495v-.99A.498.498 0 0 0 9.504 4H6z"/>
        </svg>
    );
}

export default IconPlusSmall;
